/**
 * @architecture-header 1
 * @layer app
 * @domain parallel-development
 * @responsibility Mount lane-owned feature actions into one stable shared Desktop/Mobile shell slot.
 * @state-owner route-selected workspace section and authenticated role projection
 * @allowed-imports app providers; shared workspace store; lane-owned composition functions
 * @forbidden feature-module internals; direct API clients; feature-specific behavior
 * @public-api shared workspace routes
 * @side-effects renders lane-owned actions
 * @tests WorkspaceSectionActions.test.tsx and workspace Playwright flows
 */

import { useWorkspaceUiStore } from '../../shared/model/workspace-store';
import { useActiveRole } from '../providers/ActiveRoleProvider';
import { agentASectionActions } from './agent-a/SectionActions';
import { agentBSectionActions } from './agent-b/SectionActions';
import type { WorkspaceActionSurface, WorkspaceSectionActionContext } from './types';

export function WorkspaceSectionActions({
  className,
  surface,
}: {
  readonly className?: string;
  readonly surface: WorkspaceActionSurface;
}) {
  const role = useActiveRole();
  const section = useWorkspaceUiStore((state) => state.section);
  const context: WorkspaceSectionActionContext = { role, section, surface };
  const agentA = agentASectionActions(context);
  const agentB = agentBSectionActions(context);

  if (!agentA && !agentB) return null;
  const content = (
    <>
      {agentA}
      {agentB}
    </>
  );
  return className ? <div className={className}>{content}</div> : content;
}
